<template>
  <el-card class="user">
    <div class="base-info">
      <h4 class="user-name">{{ userInfo.name }}</h4>
      <el-row>
        <el-col :span="12">
          注册时间: <span class="time">{{ userInfo.create_time }}</span>
        </el-col>
        <el-col :span="12">
          最近一次登录: <span class="time">{{ userInfo.last_login_time }} </span>
        </el-col>
      </el-row>
    </div>
    <div class="base-info-body">
      <div class="item-wrapper" v-for="(item, index) in WrapperList" :key="index">
        <div class="item-box">
          <span>
            <i
              :class="item.isActive ? 'el-icon-circle-check' : 'el-icon-warning-outline'"
              :style="{ color: item.isActive ? '#67c23a' : '#f56c6c' }"
            ></i>
            <span class="ml10">{{ item.label }}</span>
          </span>
          <span class="item-placeholder">{{
            item.showDetail && item.value ? `${item.value}, ${item.placeholder}` : item.placeholder
          }}</span>
          <span class="item-opt" @click="handleOpt(item)">修改</span>
        </div>
      </div>
    </div>
    <el-dialog title="修改" v-if="dialogProps" destroy-on-close :visible.sync="dialogStatus" width="40%">
      <component
        ref="dialogRef"
        :is="dialogProps.component"
        v-model="dialogProps.value"
        :is-active="dialogProps.isActive"
      ></component>
      <span slot="footer">
        <el-button type="primary" @click="handleSubmit(dialogProps.api)">确定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
import { getUserInfo, updatePassword, bindPhone, bindEmail } from '@/apis/userInfo'
import { userInfoBus } from '@/bus/bus'
import UpdatePassword from './UpdatePassword.vue'
import BindEmail from './BindEmail.vue'
import BindPhone from './BindPhone.vue'
export default {
  components: {
    UpdatePassword,
    BindEmail,
    BindPhone,
  },
  data() {
    return {
      WrapperList: [
        {
          prop: 'password',
          label: '登录密码',
          isActive: false,
          placeholder: '密码由 8-20 个字符组成，需同时包含数字、字母以及特殊符号 (1@#$%^＆*0等非空格符号）',
          showDetail: false,
          component: UpdatePassword,
          api: updatePassword,
        },
        {
          prop: 'phone',
          label: '绑定手机',
          isActive: false,
          placeholder: '手机可用于登录和找回密码',
          showDetail: true,
          value: '',
          component: BindPhone,
          api: bindPhone,
        },
        {
          prop: 'email',
          label: '绑定邮箱',
          isActive: false,
          placeholder: '邮箱可用于登录和找回密码',
          showDetail: true,
          value: '',
          component: BindEmail,
          api: bindEmail,
        },
      ],
      userInfo: {},
      dialogStatus: false,
      dialogProps: null,
    }
  },
  methods: {
    async getBaseInfo() {
      const res = await getUserInfo()
      if (res.code === 200) {
        this.userInfo = res.data
        userInfoBus.$emit('userinfo-change', res.data)
        this.$set(this.WrapperList[0], 'isActive', res.data.is_password)
        this.$set(this.WrapperList[1], 'isActive', res.data.phone_is_active)
        this.$set(this.WrapperList[2], 'isActive', res.data.email_is_active)
        this.$set(this.WrapperList[1], 'value', res.data.phone)
        this.$set(this.WrapperList[2], 'value', res.data.email)
      }
    },
    handleOpt(item) {
      this.dialogStatus = true
      this.dialogProps = item
    },
    async handleSubmit(api) {
      const valid = await this.$refs.dialogRef.$refs.formRef.validate().catch(() => false)
      if (valid) {
        const form = this.$refs.dialogRef.form
        const res = await api(form)
        if (res.code === 200) {
          this.$message.success('修改成功！')
        }
        this.dialogStatus = false
        this.getBaseInfo()
      }
    },
  },
  mounted() {
    this.getBaseInfo()
  },
}
</script>
<style lang="scss">
.user {
  color: #1e1f23;
  .base-info {
    padding: 0 2%;
    .user-name {
      line-height: 56px;
      font-size: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      max-width: 220px;
    }
    .time {
      color: #686c78;
    }
  }
  .base-info-body {
    margin-top: 20px;
    .item-wrapper {
      border-bottom: 1ox solid #e6eaef;
      .item-box {
        border-bottom: 1px solid #e6eaef;
        display: flex;
        width: 100%;
        min-height: 71px;
        padding: 0 2%;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        &:hover {
          background-color: #f7f9fc;
        }
        .item-placeholder {
          font-size: 14px;
          color: #999ea8;
          letter-spacing: 0;
          font-weight: 400;
          padding: 0 6%;
          flex: 1;
        }
        .item-opt {
          flex: 0 0 50px;
          color: #0b6fd6;
          letter-spacing: 0;
          line-height: 20px;
          text-align: right;
        }
      }
    }
  }
}
</style>
